import React from 'react'

import { Container } from './styles/Container'
import { InlineText } from './styles/InlineText'
import { StyledDoubleClaim } from './styles/StyledDoubleClaim'

interface Props {
  active: boolean
  title: string
  clickHandler: (() => void) | undefined
}

export default function DoubleClaim({ title, active, clickHandler }: Props) {
  if (!title || !title.includes('|')) {
    return null
  }

  const labels = title.split('|').map((element) => element.trim())

  return (
    <>
      <InlineText active={active}>
        <span>{labels[0]}</span>
        <span>{labels[1]}</span>
      </InlineText>
      <Container>
        <StyledDoubleClaim
          active={active}
          bottomClick={clickHandler}
          topLabel={labels[0]}
          bottomLabel={labels[1]}
        />
      </Container>
    </>
  )
}
